import React from 'react';
import bg from '@/assets/homepage/bg-4.png';
import logo from '@/assets/homepage/logo-text-white.png';
import MailIcon from '@/assets/homepage/Icon.png';
import Location from '@/assets/homepage/location.png';
import Button1 from '@/assets/homepage/Button1.png';
import Button2 from '@/assets/homepage/Button2.png';
import Button3 from '@/assets/homepage/Button3.png';
const Footer: React.FC = () => (
  <footer className='relative w-full z-10 bg-no-repeat py-20 px-4' style={{ backgroundImage: `url(${bg})` }}>
    <div className='max-[1280px] mx-auto flex flex-col md:flex-row justify-between items-center gap-8'>
      <div className='flex flex-col items-center md:items-start gap-4'>
        {/* Logo Placeholder */}
        <img src={logo} className='w-full' alt='' />
        <div className='w-full grid grid-cols-4 gap-4 mt-[72px] max-[768px]:grid-cols-2 max-[560px]:grid-cols-1'>
          <div className='text-sm text-white flex items-center gap-4'>
            <img src={MailIcon} className='w-6' alt='' /> hello@tevellab.com
          </div>
          <div className='text-sm text-white flex items-center gap-4'>
            {' '}
            <img src={MailIcon} className='w-6' alt='' />
            +84 123 456 000
          </div>
          <div className='text-sm text-left text-white flex items-center gap-4'>
            {' '}
            <img src={Location} className='w-6' alt='' />
            720A Dien Bien Phu, Binh Thanh Ward, Ho Chi Minh City, Viet nam
          </div>
          <div className='flex gap-4 items-start justify-end max-[560px]:justify-start'>
            {/* Social Buttons Placeholder */}
            <button className='w-[52px] h-[52px] bg-none border-none flex items-center justify-center'>
              <img src={Button1} alt='' />
            </button>
            <button className='w-[52px] h-[52px] bg-none border-noneflex items-center justify-center'>
              {' '}
              <img src={Button2} alt='' />
            </button>
            <button className='w-[52px] h-[52px] bg-none border-none flex items-center justify-center'>
              {' '}
              <img src={Button3} alt='' />
            </button>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
